import { render, staticRenderFns } from "./TermFeeRequest.vue?vue&type=template&id=9213a3e4"
import script from "./TermFeeRequest.vue?vue&type=script&lang=js"
export * from "./TermFeeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports